import { Nav } from './components/nav';
import { Hero } from './components/hero';
import { About } from './components/about';
import { Expertise } from './components/expertise';
import { Portfolio } from './components/portfolio';
import { Contact } from './components/contact';
import { Arrow } from './components/ui';
import './App.css';

export default function App() {
  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <Nav />
      <main id="main" tabIndex="-1">
        <Hero />
        <Portfolio />
        <About />
        <Expertise />
        <Contact />
      </main>
      <footer className="site-footer container">
        <a className="wordmark" href="#home" aria-label="Maycie Morris, back to top">maycie<span>morris</span><span className="wordmark-dot">.</span></a>
        <p>Designed and developed by Maycie Morris.</p>
        <a className="text-link" href="#home">Back to top <Arrow direction="up" /></a>
        <small>© {new Date().getFullYear()} Maycie Morris</small>
      </footer>
    </>
  );
}
